const getters = {
  roleList: (state) => state.roleList,
  defaultRoleInfo: (state) => state.defaultRoleInfo,
  role_id: (state) => state.defaultRoleInfo.role_id,
  vuexInitData: (state) => state.vuexInitData,
  globalNotice: (state) => state.globalNotice,
  userInfo: (state) => state.userInfo,
  indexData: (state) => state.indexData,
};

export default getters;
